import { useMemo } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { transition, variants } from './variants';
import { useLocation, useNavigate } from 'react-router-dom';
import { useOrganization } from '../../utils/OrganizationContext';
import Header from './Header';
import WidgetGenerator from '../../components/WidgetComponents/WidgetGenerator';
import WidgetCollection from '../../components/WidgetComponents/WidgetCollection';
import styles from './Widgets.module.css';

// main
export default function Widgets() {
    const navigate = useNavigate();
    const location = useLocation();
    const { activeOrganization } = useOrganization();
    const { generator, qrId } = location.state || {}
    
    const hasWidgetAccess = useMemo(() => activeOrganization?.plan?.widgets > 0, [activeOrganization?.plan?.widgets]);
    const isGenerator = useMemo(() => !!generator || !!qrId, [generator, qrId]);

    const handleReturn = useMemo(() => {
        if (isGenerator) {
            return (
                <motion.div
                    key='generator'
                    className={styles.generator}
                    transition={transition}
                    variants={variants}
                    initial='initial'
                    animate='animate'
                    exit='initial'
                >
                    <WidgetGenerator qrId={qrId} generator={generator} />
                </motion.div>
            )
        } else {
            return (
                <motion.div
                    key='collection'
                    className={styles.collection}
                    transition={transition}
                    variants={variants}
                    initial='initial'
                    animate='animate'
                    exit='initial'
                >
                    <WidgetCollection />
                </motion.div>
            )
        }
    },[isGenerator, generator, qrId]);

    if (!hasWidgetAccess) {
        return (
            <div className={styles.wrapper}>
                <div className={styles.container}>
                    <div className={styles.upgradeContainer}>
                        <h2>Widgets Not Available</h2>
                        <p>Upgrade your plan to access our Widget feature and embed QR codes on your website.</p>
                        <button className={styles.upgradeBtn} onClick={() => navigate('/organizations/settings')}>
                            Upgrade Now
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <AnimatePresence mode='wait'>
                    <motion.div
                        className={styles.widgets}
                        transition={transition}
                        variants={variants}
                        initial='initial'
                        animate='animate'
                        exit='initial'
                    >
                        <Header isGenerator={isGenerator} qrId={qrId} fromNewCollection={location.state?.fromNewCollection} />
                        <AnimatePresence mode='wait'>
                            {handleReturn}
                        </AnimatePresence>
                    </motion.div>
                </AnimatePresence>
            </div>
        </div>
    );
};